<div
  class="disallow-pointer-container"
  [ngClass]="{
    hidden: hideWhatsNewBlock,
  }"
>
  <div
    class="whats-new-container"
    [ngClass]="{
      step0override: currentStep === 0,
      step1override: currentStep === 1,
      step2override: currentStep === 2,
      step3override: currentStep === 3,
      step4override: currentStep === 4,
      step5override: currentStep === 5,
      step6override: currentStep === 6,
    }"
  >
    @if (currentStep === 0) {
      <div class="wizard-block wizard-block-{{ currentStep }}">
        <div class="flex-row justify-content-center">
          <img style="width: 100px" src="assets/PlowOpsLogo_Snowflake.svg" alt="PlowOps 3.0" />
        </div>
        <div class="flex-row justify-content-center pt-15">
          <h1>Welcome to PlowOps 3.0</h1>
        </div>
        <p>Our latest update brings some big changes to the look and feel of PlowOps. Join us for a tour of the new layout.</p>
        <div class="flex-row justify-content-end">
          <button mat-button color="accent" (click)="skip()">Skip</button>
          <button mat-button color="primary" (click)="next(currentStep + 1)">Next</button>
        </div>
      </div>
    }

    @if (currentStep === 1) {
      <div class="wizard-block wizard-block-{{ currentStep }}">
        <div class="tooltip-pointer"></div>
        <div class="flex-row">
          <h1>Top Navigation Bar</h1>
        </div>
        <p>Search for drivers, vehicles and routes. See live weather and active weather alerts, get support, and configure your account.</p>
        <div class="flex-row justify-content-space-between">
          <p>{{ currentStep }}/6</p>
          <div class="flex-row justify-content-end">
            <button mat-button color="primary" (click)="next(currentStep + 1)">Next</button>
          </div>
        </div>
      </div>
    }

    @if (currentStep === 2) {
      <div class="wizard-block wizard-block-{{ currentStep }}">
        <div class="tooltip-pointer"></div>
        <div class="flex-row">
          <h1>Left Panel</h1>
        </div>
        <p>
          View and select vehicles from the list on the left. Routes are now part of this left list as well. Insights have also been moved
          from the top bar to this left menu.
        </p>
        <div class="flex-row justify-content-space-between">
          <p>{{ currentStep }}/6</p>
          <div class="flex-row justify-content-end">
            <button mat-button color="accent" (click)="next(currentStep - 1)">Back</button>
            <button mat-button color="primary" (click)="next(currentStep + 1)">Next</button>
          </div>
        </div>
      </div>
    }

    @if (currentStep === 3) {
      <div class="wizard-block wizard-block-{{ currentStep }}">
        <div class="tooltip-pointer"></div>
        <div class="flex-row">
          <h1>Quick Actions Panel</h1>
        </div>
        <p>
          All vehicle interactions take place here. Create route assignments, send messages, view driver observations, see active alerts,
          and view quick insights.
        </p>
        <div class="flex-row justify-content-space-between">
          <p>{{ currentStep }}/6</p>
          <div class="flex-row justify-content-end">
            <button mat-button color="accent" (click)="next(currentStep - 1)">Back</button>
            <button mat-button color="primary" (click)="next(currentStep + 1)">Next</button>
          </div>
        </div>
      </div>
    }

    @if (currentStep === 4) {
      <div class="wizard-block wizard-block-{{ currentStep }}">
        <div class="tooltip-pointer"></div>
        <div class="flex-row">
          <h1>Basemap Switcher</h1>
        </div>
        <p>
          Basemap Switcher has been redesigned to be simpler and easier to use. View default map layers or add your own using the My Layer
          library.
        </p>
        <div class="flex-row justify-content-space-between">
          <p>{{ currentStep }}/6</p>
          <div class="flex-row justify-content-end">
            <button mat-button color="accent" (click)="next(currentStep - 1)">Back</button>
            <button mat-button color="primary" (click)="next(currentStep + 1)">Next</button>
          </div>
        </div>
      </div>
    }

    @if (currentStep === 5) {
      <div class="wizard-block wizard-block-{{ currentStep }}">
        <div class="tooltip-pointer"></div>
        <div class="flex-row">
          <h1>Map Themes</h1>
        </div>
        <p>
          Visualize your operations using any of our map themes. Choose from GPS tracks, Pass Count Map (formerly coverage map), Time Map
          (formerly currency map) and Route Status Map.
        </p>
        <div class="flex-row justify-content-space-between">
          <p>{{ currentStep }}/6</p>
          <div class="flex-row justify-content-end">
            <button mat-button color="accent" (click)="next(currentStep - 1)">Back</button>
            <button mat-button color="primary" (click)="next(currentStep + 1)">Next</button>
          </div>
        </div>
      </div>
    }

    @if (currentStep === 6) {
      <div class="wizard-block wizard-block-{{ currentStep }}">
        <div class="flex-row justify-content-center">
          <img style="width: 100px" src="assets/PlowOpsLogo_Snowflake.svg" alt="PlowOps 3.0" />
        </div>
        <div class="flex-row justify-content-center pt-15">
          <h1>Welcome to PlowOps 3.0</h1>
        </div>
        <p>
          Thanks for taking the tour! If you have any question or feedback please feel free to reach out to
          <a class="ops-link" href="mailto:support@plowops.com">support&#64;plowops.com</a>
        </p>
        <div class="flex-row justify-content-end">
          <button mat-button color="accent" (click)="next(currentStep - 1)">Back</button>
          <button mat-button color="primary" (click)="next(currentStep + 1)">Close</button>
        </div>
      </div>
    }
  </div>
</div>
